import { getLang, setLang, t } from './index'

/** EN / ES switch in the top bar (23 Oct 2026). */
export function LangToggle() {
  const lang = getLang()
  const next = lang === 'es' ? 'en' : 'es'
  return (
    <button
      type="button"
      onClick={() => setLang(next)}
      aria-label={lang === 'es' ? t('Switch to English') : t('Switch to Spanish')}
      title={lang === 'es' ? t('Switch to English') : t('Switch to Spanish')}
      className="inline-flex items-center gap-0.5 text-xs font-semibold px-2 py-1 rounded hover:bg-accent transition-colors"
    >
      <span className={lang === 'en' ? 'text-primary' : 'text-foreground-muted'}>EN</span>
      <span className="text-foreground-muted">/</span>
      <span className={lang === 'es' ? 'text-primary' : 'text-foreground-muted'}>ES</span>
    </button>
  )
}
